import { TableItem } from 'components/atoms';
import { Table, TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import { useTableColumnsVisibility } from 'hooks/useTableColumnsVisibility';
import { useTranslation } from 'react-i18next';
import { useGetContactsListInfinite } from 'services/contacts-list/index';
import { IContact } from 'services/contacts-list/types';
import { INodes } from 'services/types';
import { magellanColumns } from 'types/components/table/table.types';
import { getNodes } from 'utils/table/nodes.utils';

enum SORT_COLUMNS {
  firstName,
  lastName,
  phoneNumber,
  // isActive,
  email,
}

const ContactList = () => {
  const { t } = useTranslation();
  const i18nextPrefix = 'contacts-list';

  const columnsVisibility = useTableColumnsVisibility(
    'ContactList',
    SORT_COLUMNS
  );

  const { data, isLoading, fetchNextPage, isFetchingNextPage } =
    useGetContactsListInfinite({ itemCount: 25 });

  const tableData: INodes<IContact> = getNodes<IContact>(data?.pages.flat());

  return (
    <TopbarPage
      topbar={
        <TopBar
          title={t(`${i18nextPrefix}.title.list`)}
          hideBackButton
          topbarContent={
            <>
              <Table.CustomColumnsButton
                columns={SORT_COLUMNS}
                isClear
                visibility={columnsVisibility}
                i18nextPrefix='input.label'
                customI18next=''
              />
            </>
          }
        />
      }>
      <Table
        id={columnsVisibility.tableId}
        loading={isLoading || isFetchingNextPage}
        onFullyScroll={fetchNextPage}
        data={tableData}
        columns={magellanColumns<IContact>([
          {
            label: t('input.label.firstName'),
            renderCell: item => (
              <TableItem>
                <TableItem.Text text={item.firstName} />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(SORT_COLUMNS.firstName),
          },
          {
            label: t('input.label.lastName'),
            renderCell: item => (
              <TableItem>
                <TableItem.Text text={item.lastName} />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(SORT_COLUMNS.lastName),
          },
          {
            label: t('input.label.phoneNumber'),
            renderCell: item => (
              <TableItem>
                <TableItem.Text text={item.phoneNumber} />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(SORT_COLUMNS.phoneNumber),
          },

          {
            label: t('input.label.email'),
            renderCell: item => (
              <TableItem>
                <TableItem.Text text={item.email} />
              </TableItem>
            ),
            // resize: true,
            hide: columnsVisibility.hide(SORT_COLUMNS.email),
          },

          // {
          //   label: t('input.label.isActive'),
          //   renderCell: item => (
          //     <TableItem>
          //       <LabeledStatus.Active
          //         status={
          //           item.isActive
          //             ? ACTIVE_STATUS.Active
          //             : ACTIVE_STATUS.Inactive
          //         }
          //       />
          //     </TableItem>
          //   ),
          //   hide: columnsVisibility.hide(SORT_COLUMNS.isActive),
          // },
        ])}
      />
    </TopbarPage>
  );
};

export default ContactList;
